import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withRouter } from "react-router";
import TagManagerService from 'services/TagManager';
import PubSub from 'services/PubSub'

let mX = 0;

const Item = (props) => {
    const category = props.category;
    if(!category) return '';
    const url = props.url;
    const button = useRef(null);

    const [isMobile, setMobile] = useState(false);

    useEffect(()=>{
        if (window) {
            checkViewport();
            window.addEventListener("resize", checkViewport);
        }

        return function cleanup() {
            if (window) {
                window.removeEventListener("resize", checkViewport);
            }
        }
    }, []);

    const checkViewport = ()  => {
        if(!document) return false;
        const $body = document.querySelector('body');
        const viewportWidth = $body.clientWidth;
        const currentIsMobile = viewportWidth <= 1024;

        if (currentIsMobile !== isMobile) {
            setMobile(currentIsMobile);
        }
    };

    const setTagManager = (e, url) => {
        const title_path = url.replace('/', '').replace('_', ' ');
        const title_crumbs = title_path.charAt(0).toUpperCase() + title_path.slice(1).replace(/-/g, " ");
        TagManagerService.menu(title_crumbs, title_crumbs.split('/').pop(), 'Menú Lateral');
    }

    const noItems = !!category.items.length;

    const clickCategory = (event, url, title) => {
        event.preventDefault();

        if(isMobile){
            if(!category.items.length){
                props.history.push(url);
                setTagManager(event, url);
            } else {
                props.showSubCats(category, props.index, title);

                PubSub.dispatch('subcat_slide_in', true);
            }
        } else {
            props.history.push(url);
            setTagManager(event, url);
        }
    }

    const handleHover = (event, i, category) => {
        if (!(event.pageX > mX + 6 && mX !== 0 && window.outerWidth >= 840)) {
            props.showSubCats(category, i);
        }

        mX = event.pageX;
    }


    return (
        <>
            <li className={"catalog-aside-nav-item category" + (props.over ? ' over ' : '')} onMouseEnter={event => handleHover(event,props.index, category)} ref={button}>
                <Link to={url ? url.toLowerCase() : ''} onClick={(e) => clickCategory(e, url, (category.name || category.title))}>
                    {(category.name || category.title)}
                    {noItems && <i className="font-icn arrow-up" ref={button} />}
                </Link>
            </li>
        </>
    )
}

Item.propTypes = {
    category: PropTypes.object,
    url: PropTypes.string,
    showSubCats: PropTypes.func,
    over: PropTypes.bool,
    index: PropTypes.number,
    history: PropTypes.object
}

export default withRouter(Item);
